<template>
  <modal :show.sync="modals.classic">
    <h4 slot="header" class="title title-up">
      {{ $t("app.modules.users.add.title") }}
    </h4>
    <ValidationObserver ref="formAdd" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitNewUser)">
        <div class="row text-left">
          <div :class="sizes">
            <ValidationProvider
              :name="$t('app.modules.users.headers.name')"
              rules="required"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="text"
                :error="failed ? required_text : null"
                :hasSuccess="passed"
                :placeholder="$t('app.modules.users.headers.name')"
                :label="$t('app.modules.users.headers.name')"
                v-model="item.nombre"
              >
              </fg-input>
            </ValidationProvider>
          </div>
          <div :class="sizes">
            <ValidationProvider
              :name="$t('app.modules.users.headers.mail')"
              rules="required|email"
              v-slot="{ passed, failed }"
            >
              <fg-input
                type="email"
                :error="failed ? required_text : null"
                :hasSuccess="passed"
                :placeholder="$t('app.modules.users.headers.mail')"
                :label="$t('app.modules.users.headers.mail')"
                v-model="item.correo"
              >
              </fg-input>
            </ValidationProvider>
          </div>
          <div :class="sizes">
            <div style="margin-bottom: -13px;" class=" form-group has-label">
              <label for="">{{ $t("app.modules.users.headers.role") }}</label>
            </div>
            <el-select
              size="large"
              filterable
              placeholder="Selecciona rol"
              v-model="item.roles[0].roles_idRol"
              @change="isBlockedRole"
            >
              <el-option
                v-for="rol in roles"
                :value="rol.roles_idRol"
                :label="rol.nombre"
                :key="rol.roles_idRol"
              >
              </el-option>
            </el-select>
            <div
              v-if="selectedEmpty"
              class="text-danger invalid-feedback"
              style="display: block;"
            >
              {{ required_text }}
            </div>
          </div>
        </div>
        <div class="col-sm-6 form-group has-label">
          <div style="margin-bottom: -5px; margin-left: -12px;">
            <label>{{ $t("app.general.state") }}</label>
          </div>
          <template>
            <n-switch v-model="item.activo" :disabled="disabled_b">
              <i class="now-ui-icons ui-1_check" slot="on"></i>
              <i class="now-ui-icons ui-1_simple-remove" slot="off"></i>
            </n-switch>
          </template>
        </div>
        <div
          slot="footer"
          style="margin-top: 10px; padding-top: 20px;border-top: outset;"
          class="text-right"
        >
          <n-button class="pull-left" @click.native="cancelAdd()">{{
            $t("app.buttons.cancel")
          }}</n-button>
          <n-button native-type="submit" type="primary">{{
            $t("app.buttons.save")
          }}</n-button>
        </div>
      </form>
    </ValidationObserver>
  </modal>
</template>
<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      disabled_b: false,
      selectedEmpty: false,
      required_text: this.$t("app.general.required"),
      sizes: "col-md-6 col-sm-12",
      roles: [],
      item: {
        idUsuario: 0,
        nombre: "",
        correo: "",
        alias: "",
        activo: true,
        roles: [
          {
            idRol: 0,
            nombreRol: "rolname",
            empresa: "empresa",
            idEmpresa: 0,
            activo: true,
            activoStr: "activo",
            fechaRegistro: "2020-11-09T16:56:18.906Z",
            idRolUsuario: 0,
            roles_idRol: 0
          }
        ]
      },
      modals: {
        classic: false
      }
    };
  },
  computed: {
    ...mapState(["availableLangs"])
  },
  created() {
    /*
    this.item.langs = this.availableLangs.map(lang => ({
      idioma_idIdioma: lang.idIdioma,
      idioma: lang.idioma,
      nombre: "",
      descripcion: ""
    }));*/
  },
  mounted() {
    EventBus.$on("usuario-add", async () => {
      this.tableData = [];
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.getRoles();
      this.$swal.close();
      this.modals.classic = true;
    });
  },
  methods: {
    async isBlockedRole(val) {
      var val_i = this.item.roles[0].roles_idRol;
      this.disabled_b = false;
      console.log(val_i);
      for (var i = 0; i < this.roles.length; i++) {
        if (this.roles[i].id == val_i) {
          if (this.roles[i].deshabilitar) {
            this.disabled_b = false;
          } else {
            this.disabled_b = true;
          }
          break;
        }
      }
      if (this.disabled_b) {
        this.item.activo = true;
      }
    },
    async submitNewUser() {
      if (this.item.roles[0].roles_idRol < 1) {
        this.selectedEmpty = true;
      } else {
        this.$swal.fire({
          title: this.$t("app.promps.wait"),
          html:
            '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
          showConfirmButton: false
        });

        this.selectedEmpty = false;
        console.log("Agregar un nuevo rol");
        console.log(this.item);
        this.existUser();
        this.$swal.close();
      }
    },
    async addNewUser() {
      await this.$http
        .post(route("Usuarios/addUser"), this.item)
        .then(
          async response => {
            if (response.body.code === 200) {
              this.notifyMessage("success", this.$t("app.promps.save_success"));
              EventBus.$emit("reload-items");
              this.cancelAdd();
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.trubbleSave = true;
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    async existUser() {
      await this.$http
        .post(route("Usuarios/postExistUsuario"), this.item)
        .then(
          async response => {
            if (response.body.code === 200) {
              if (response.body.exist) {
                this.notifyMessage(
                  "danger",
                  this.$t("app.modules.users.headers.duplicated")
                );
              } else {
                await this.addNewUser();
              }
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    async getRoles() {
      var payload = {
        id: 0,
        claveIdioma: this.$store.state.lang,
        usuario: 0
      };
      await this.$http
        .post(route("Roles/rolesVista"), payload)
        .then(
          async response => {
            if (response.body.code === 200) {
              console.log("Response de roles" + response.body.roles);
              this.roles = response.body.roles.filter(
                r => !r.externo && r.active
              );
              this.roles.push({
                idRol: 0,
                rol: "",
                empresa_idEmpresa: 0,
                activo: true,
                fechaRegistro: "",
                fechaEdicion: "",
                idRolTraduccion: 0,
                nombre: "Sin asignar",
                descripcion: "Sin asignar",
                idIdioma: 0,
                idioma: "",
                clave: "",
                roles_idRol: 0
              });
            } else {
              this.notifyMessage("danger", this.$t("app.promps.error"));
            }
          },
          error => {
            this.notifyMessage("danger", this.$t("app.promps.error"));
          }
        )
        .finally(() => {});
    },
    createDate() {
      var date = new Date();
      var str =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " " +
        date.getHours() +
        ":" +
        date.getMinutes() +
        ":" +
        date.getSeconds();
      return str;
    },
    cancelAdd() {
      this.item.roles[0].roles_idRol = 0;
      this.item.nombre = "";
      this.item.alias = "";
      this.item.correo = "";
      this.$refs.formAdd.reset();
      this.modals.classic = false;
    },
    async submitNewUsuario() {
      this.$swal.fire({
        title: this.$t("app.promps.wait"),
        html:
          '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
        showConfirmButton: false
      });
      await this.addNewRole();
      this.$swal.close();
    },
    async addNewRole() {}
  }
};
</script>
<style>
.extended-forms .el-select {
  width: 100%;
  margin-bottom: 30px;
}
.card .alert {
  position: relative !important;
  width: 100%;
}

.modal-content .modal-header {
  padding-bottom: 24px;
  box-shadow: 0px 2px 5px 0px #00000021;
}

.modal-content .modal-body + .modal-footer {
  padding-top: 20px !important;
  background-color: #efefefb3;
}
</style>
